import { WithUsagesData } from "./useUsagesCells";

export function getUsageCellLabel(params: {
  cell: WithUsagesData["cells"][number];
}): string | undefined {
  let str: string = "";
  // prepend so it doesn't get cutoff by ellipsis
  if (params.cell.onlyExistsInPublished) {
    str += "*";
  }
  if (params.cell.label) {
    str += params.cell.label;
  } else if (params.cell.unnamedCellIndex != null) {
    str += `Unnamed Cell ${params.cell.unnamedCellIndex + 1}`;
  }
  return str;
}
